
import { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import ViewURL from "../../Modal/ViewURL";

const ComplaintDetailsPopUp = (props) => {

    const { handleComplaintDetails, heading, gridData, isLoading } = props
    const { t } = useTranslation()

    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)



    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    return (
        <>
            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <h5 className="card-title fw-bold" id="exampleModalLongTitle">
                                {heading}
                            </h5>
                            <button onClick={() => handleComplaintDetails()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">

                            <div className="row" >
                                <div className="col-12  " >
                                    <div className="table-responsive pt-3">
                                        <table className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.AcknowledgedDate')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.ComplaintReceivedDate')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.ComplaintUploadDate')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.UploadedBy')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.ComplaintPhoto')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.Remark')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.OfficerName')}</th>

                                                </tr>

                                            </thead>
                                            <tbody>

                                                <tr>
                                                    <td className="py-1" align="center">1</td>
                                                    <td >{gridData?.acknowledged_Date ? gridData?.acknowledged_Date : '-'}</td>
                                                    <td >{gridData?.received_Date ? gridData?.received_Date : '-'}</td>
                                                    <td >{gridData?.uploadDate ? moment(gridData?.uploadDate).format('YYYY/MM/DD') : '-'}</td>
                                                    <td className="nowrap" >{gridData?.createBy_OfficerName ? gridData?.createBy_OfficerName : '-'}</td>
                                                    {/* <td className="text-center">
                                                        <span className="cursor-pointer">
                                                            <i class="fa-solid fa-image text-danger"></i>
                                                        </span>
                                                    </td> */}
                                                    <td className="text-center pt-2">
                                                        {
                                                            (gridData?.uploadPhoto == null) ?
                                                                <span>-</span>
                                                                :
                                                                <button className="view_button " onClick={() => handleShowImage(gridData?.uploadPhoto)}>
                                                                    {/* {t('EncroachmentDashboard.View')} */}
                                                                    <i class="fa-regular fa-image"></i>
                                                                </button>
                                                        }

                                                    </td>
                                                    <td className="nowrap" >{gridData?.uploadRemark ? gridData?.uploadRemark : '-'}</td>
                                                    <td className="nowrap" >{gridData?.pathakName ? gridData?.pathakName : '-'}</td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>




                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="row">
                                {/* <div className="col-12 pt-3">
                                    <button
                                        type='button'
                                        // onClick={() => confirmBtnCallBack(deleteRecord)}
                                        className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                       
                                        {t('EncroachmentDashboard.Forward')}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleSiteVerificationDetails}
                                        className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                        <i class="fa-solid fa-xmark pe-1"></i> Cancel

                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showImagePopup ?
                        <ViewURL
                            Heading={t('EncroachmentDashboard.View')}
                            setshowImagePopup={setshowImagePopup}
                            ImagePopUpData={ImagePopUpData}

                        />
                        : ''
                }
            </div>

        </>);
}

export default ComplaintDetailsPopUp;